/** Paramètres → Contrôles : ce que le logiciel garantit. */
import { useCompany } from "../../company/CompanyProvider";

const ITEMS: { id: string; title: string; body: string }[] = [
  {
    id: "01",
    title: "Numérotation",
    body: "Une séquence par société et par type. Le numéro est attribué à la finalisation. Un numéro utilisé n’est jamais réattribué. En production, le compteur ne recule pas.",
  },
  {
    id: "02",
    title: "Modification",
    body: "Une pièce finalisée ne se corrige pas. Toute erreur passe par un avoir. Un brouillon déjà numéroté (PDF en cours) n’est plus éditable.",
  },
  {
    id: "03",
    title: "Intégrité",
    body: "Le contenu est snapshoté et hashé SHA-256. Le PDF scellé est déposé avant que la pièce soit considérée émise. Pas de facture validée sans archive.",
  },
  {
    id: "04",
    title: "Traçabilité",
    body: "Lien facture ↔ opération : lignes (libellé, qté, bien/service) → BIENS / SERVICES / MIXTE, dates, livraison si distincte, snapshot figé. Processus : devis → facture → avoir → paiement. Journal : utilisateur, date, action. Signature de devis : nom, phrase, empreinte, IP. Ça ouvre un brouillon, jamais une facture validée toute seule.",
  },
  {
    id: "05",
    title: "Archivage",
    body: "Copie figée dans archivage_legal/ (DD02), zone Coffre lecture seule. Conservation 10 ans. Le portail sert ce fichier, pas une page HTML.",
  },
  {
    id: "06",
    title: "Accès",
    body: "Session Suite + tuile Factures. Un compte ne voit que les sociétés qu’il atteint. Le portail client est isolé (jeton hashé).",
  },
  {
    id: "07",
    title: "Mentions obligatoires structurées",
    body: "Le logiciel décide et écrit : 293 B, escompte, pénalités + 40 €, identité, SIREN client, nature BIENS / SERVICES / MIXTE, adresse de livraison si distincte. Le pied libre n’est qu’un complément.",
  },
  {
    id: "08",
    title: "Fiche client complète",
    body: "On n’enregistre pas un client incomplet. Particulier : nom + adresse. Micro : SIRET ou SIREN, TVA grisée. Société : SIRET, SIREN, TVA et adresse. Devis, facture ou avoir n’entrent pas en ligne de compte : sans fiche complète, le client n’existe pas. Émetteur : SIRET/SIREN, adresse, forme, TVA si assujetti, capital + RCS si société (micro : champs grisés). Intra-UE hors v1.",
  },
  {
    id: "09",
    title: "Date d’opération et TVA par taux",
    body: "Facture / avoir : date d’opération distincte de l’émission (imprimée seulement si elle diffère). Pied : ventilation TVA par taux dès qu’il y en a deux (base + taxe). Un seul taux : libellé du taux.",
  },
];

export function ControlsTab() {
  const { company } = useCompany();
  const env = company?.environment === "lab" ? "lab" : "production";
  const years = company?.retention_years || 10;

  return (
    <div className="fx-co-card">
      <header className="fx-co-card__head">
        <h2>Contrôles</h2>
        <p>
          Méthode de sécurisation : contrôles documentés et permanents, piste d’audit entre la facture et
          l’opération. Pas de signature électronique qualifiée sur les factures de cette v1. Environnement : {env}.
          Conservation : {years} ans. Ce n’est pas une attestation fiscale.
        </p>
      </header>
      <ol className="fx-co-texts" style={{ margin: 0, paddingLeft: "1.25rem" }}>
        {ITEMS.map((item) => (
          <li key={item.id} style={{ marginBottom: "1rem" }}>
            <strong>
              Contrôle {item.id} — {item.title}
            </strong>
            <p className="fx-co-form__hint" style={{ marginTop: "0.35rem" }}>
              {item.body}
            </p>
          </li>
        ))}
      </ol>
    </div>
  );
}
